// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}
.loading-container ion-spinner {
  margin-bottom: 16px;
}

ion-toggle {
  font-weight: 600;
  --track-background-checked: #ed143d;
}

ion-label {
  white-space: normal !important;
}
ion-label h2 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
}
ion-label p {
  font-size: 14px;
  color: var(--ion-color-medium);
  margin-top: 4px;
  white-space: normal;
  overflow: visible;
}

.count-settings-item {
  --min-height: 0;
  --padding-top: 0;
  --padding-bottom: 12px;
  --inner-padding-end: 0;
}

.count-settings-item::part(native) {
  min-height: 0;
  align-items: flex-start;
  padding-top: 0;
}

.count-settings {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 4px;
}

.days-section,
.time-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.days-section span,
.time-section span {
  font-size: 13px;
  font-weight: 600;
  color: #888;
}

.time-section ion-chip {
  align-self: flex-start;
  margin: 0;
  border-radius: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
}

ion-popover.datetime-popover::part(content) {
  --width: 350px;
  --max-width: 90%;
  --height: auto;
}

.weekdays-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
}
.weekdays-container ion-badge {
  cursor: pointer;
  border-radius: 12px;
  background: none;
  color: #333;
  border: 1px solid #333;
  padding: 8px 15px;
  font-weight: 600;
}
.weekdays-container ion-badge.selected {
  background: #ed143d;
  color: white;
  border: 1px solid #ed143d;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/notification-preferences-modal/notification-preferences-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,gBAAA;EACA,mCAAA;AAAF;;AAGA;EACE,8BAAA;AAAF;AAEE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,eAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AADJ;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,cAAA;AAFF;;AAKA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAFF;;AAKA;;EAEE,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;AAIE;;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AADJ;;AAME;EACE,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAHJ;;AAOA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAJF;AAME;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AAJJ;AAMI;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;AAJN","sourcesContent":[".loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n\n  ion-spinner {\n    margin-bottom: 16px;\n  }\n}\n\nion-toggle {\n  font-weight: 600;\n  --track-background-checked: #ed143d;\n}\n\nion-label {\n  white-space: normal !important;\n\n  h2 {\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 4px;\n  }\n\n  p {\n    font-size: 14px;\n    color: var(--ion-color-medium);\n    margin-top: 4px;\n    white-space: normal;\n    overflow: visible;\n  }\n}\n\n.count-settings-item {\n  --min-height: 0;\n  --padding-top: 0;\n  --padding-bottom: 12px;\n  --inner-padding-end: 0;\n}\n\n.count-settings-item::part(native) {\n  min-height: 0;\n  align-items: flex-start;\n  padding-top: 0;\n}\n\n.count-settings {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-top: 4px;\n}\n\n.days-section,\n.time-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  span {\n    font-size: 13px;\n    font-weight: 600;\n    color: #888;\n  }\n}\n\n.time-section {\n  ion-chip {\n    align-self: flex-start;\n    margin: 0;\n    border-radius: 12px;\n    font-weight: 700;\n    letter-spacing: 1.2px;\n  }\n}\n\nion-popover.datetime-popover::part(content) {\n  --width: 350px;\n  --max-width: 90%;\n  --height: auto;\n}\n\n.weekdays-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  align-items: center;\n\n  ion-badge {\n    cursor: pointer;\n    border-radius: 12px;\n    background: none;\n    color: #333;\n    border: 1px solid #333;\n    padding: 8px 15px;\n    font-weight: 600;\n\n    &.selected {\n      background: #ed143d;\n      color: white;\n      border: 1px solid #ed143d;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
